/*
* Product Image ScrollTo Interaction
*
**/

import 'slick-carousel';

custom.pdpCarousel = (function() {

	var breakpoint = 768;
	var $productImages = $('.product-detail__images');
	var config = {
		infinite: true,
		dots: true,
		fade: true,
		arrows: false
	};
	var slideCount;

	function isMobile() {
		return $(window).width() < breakpoint;
	}

	function isInitialized() {
		return $productImages.hasClass('slick-initialized');
	}
	function isDiscontinued(){
		if ($('.product-detail__images .discontinued-badge').length){
			$productImages.slick('slickRemove', 0);
			$('.product-detail__images .product-image').after(`<div class="discontinued-badge">DISCONTINUED</div>`);
		}
	}
	function removeDownloadIcons(){
		if ($('.js-photo-download-pdp').length <= 0) return;
		for (let slide = 1; slide < slideCount; slide++) {
			$productImages.slick('slickRemove', slide);
		}
	}
	function slickHandler() {
		if (isMobile()) {
			if(!isInitialized()) {
				$productImages.slick(config);
				slideCount = $productImages.slick('getSlick').slideCount;
				$productImages.slick('slickRemove', slideCount - 1);
				isDiscontinued();
				removeDownloadIcons();
			}
		} else {
			if(isInitialized()) {
				$productImages.slick('unslick');
			}
		}
	}

	function init() {
		slickHandler();
		$(window).on('resize', slickHandler);
	}

	return {
		init: init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-carousel.js